import React from 'react';
import { Attachments, formatElementFromHtmlAst, MarkupElement } from 'src/functions/formatElement.htmlAst';
import { ArticleBodyStack } from './ArticleBody.styles';
import { SpacingAndSizePropKeys } from 'styles/spacing';
import useFeatureFlag from 'src/hooks/useFeatureFlag';
import RawHtmlComponents from 'molecules/RawHtmlComponents/RawHtmlComponents';

interface ArticleBodyProps {
  id?: string;
  attachments?: Attachments;
  contentHtmlAst?: MarkupElement[];
  children?: React.ReactNode;
  className?: string;
  maxWidth?: SpacingAndSizePropKeys;
}

const ArticleBody = ({
  id,
  contentHtmlAst,
  attachments,
  children,
  className,
  maxWidth = 'width-xl',
}: ArticleBodyProps): JSX.Element => {
  const isReworkMarkupHtml = useFeatureFlag('rework_markup_html');

  const elementContentHtmlAst = isReworkMarkupHtml ? (
    <RawHtmlComponents
      contentHtmlAst={contentHtmlAst}
      attachments={attachments}
    />
  ) : (
    contentHtmlAst?.map((child, index) =>
      formatElementFromHtmlAst({
        element: child,
        key: `${index}`,
        attachmentList: attachments,
      })
    )
  );

  return (
    <ArticleBodyStack
      id={id}
      className={className}
      direction='column'
      maxWidth={maxWidth}
      gap={isReworkMarkupHtml ? 'spacing-xl' : 'spacing-none'}
    >
      {children ? children : elementContentHtmlAst}
    </ArticleBodyStack>
  );
};

export default ArticleBody;
